module.exports = __webpack_public_path__ + "media/country_flags/bb-0e8d1978.png";